import AdvancedSettings from "./advanced-settings";
import RegistrationGating from "./registration-gating";
import "../settings.scss";

const RegistrationSettings: React.FC = () => {

	return (
		<>
			<div className="settings-panel-container">
				<div className="panel-body">
					{/* FUTURE DEV - this feature will be a future implementation */}
					{/* <SingleSignOn /> */}
					<RegistrationGating />
					<p className="advanced-settings-text">Advanced settings</p>
					<AdvancedSettings />
				</div>
			</div>
		</>
	);
};

export default RegistrationSettings;